import React from 'react';
import PerformanceMetricsList from '../MetricsStep/PerformanceMetricsList';

const MetricsTab = () => {
  return <PerformanceMetricsList isReadOnly />;
};

export default MetricsTab;
